<template>
  <div class="combo-market-4">
    <div class="m-market-row combo-market-4-title">
      <div
        v-for="(item, index) in markets[0].outcomes.order"
        :key="index"
        class="m-outcome m-outcome-desc"
      >
        <span class="m-outcome-desc-name">{{ markets[0].outcomes.map[item].description }}</span>
      </div>
    </div>

    <ComboMarket4Item
      v-for="(market, i) in markets"
      :key="i"
      :market="market"
      :event="event"
      :visible="visible"
    />
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { useDetailStore } from '@ms/stores/matchDetail'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import ComboMarket4Item from './ComboMarket4Item.vue'

export default {
  name: 'ComboMarket4',
  components: {
    ComboMarket4Item
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    group: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const { event } = storeToRefs(useMatchDetailStore())

    const { comboMarketGroups } = storeToRefs(useDetailStore())

    const markets = computed(() => {
      const { comboType, comboGroupName, marketGroups } = props.group

      const list = []
      marketGroups.forEach((x) => {
        if (x.markets.length) {
          const id = x.markets[0].id
          list.push(comboMarketGroups.value.map[`${comboType}_${comboGroupName}_${id}`])
        }
      })

      return list
    })

    return {
      event,
      markets
    }
  }
}
</script>

<style lang="scss">
.combo-market-4 {
  display: flex;
  justify-content: space-between;
  padding-top: 30px;
}

.combo-market-4-title {
  display: block !important;
  flex: 1;
  margin-right: 6px;

  .m-outcome.m-outcome-desc {
    width: 100%;
    margin: 0 0 4px;

    .m-outcome-desc-name {
      width: 100%;
      text-align: left;
    }
  }
}
</style>
